import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Target, Zap, PlayCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['✅ TOMO 1: Meteorología Argentina para el Aula', '✅ TOMO 2: Atmósfera y Variables Meteorológicas', '✅ TOMO 3: Nubes y Fenómenos Meteorológicos Argentinos', '✅ TOMO 4: Instrumentos Meteorológicos y Observación Escolar', '✅ TOMO 5: Pronósticos, Mapas y Tecnología Meteorológica', '✅ TOMO 6: Cambio Climático y Educación Ambiental en Argentina', '🎁 BONO 1: 100 Actividades para el Aula', '🎁 BONO 2: 64 Fichas Imprimibles', '🎁 BONO 3: 50 Experimentos de Meteorología', '🎁 BONO 4: 48 Evaluaciones Listas para Usar', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const maestroFeatures = ['✅ TOMO 1: Meteorología Argentina para el Aula', '✅ TOMO 2: Atmósfera y Variables Meteorológicas', '✅ TOMO 3: Nubes y Fenómenos Meteorológicos Argentinos', '✅ TOMO 4: Instrumentos Meteorológicos y Observación Escolar', '✅ TOMO 5: Pronósticos, Mapas y Tecnología Meteorológica', '✅ TOMO 6: Cambio Climático y Educación Ambiental en Argentina', '🎁 BONO 1: 100 Actividades para el Aula', '🎁 BONO 2: 64 Fichas Imprimibles', '🎁 BONO 3: 50 Experimentos de Meteorología', '🎁 BONO 4: 48 Evaluaciones Listas para Usar', '💼 NIVEL MAESTRO: Meteorología Listo Planificaciones', '📣 NIVEL MAESTRO: Meteorología Listo Proyectos Escolares', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const comparisonRows = [{
    sit: 'Planificar una unidad completa de meteorología',
    sin: 'Armás desde cero cada año',
    con: 'Planificación anual completa lista para adaptar'
  }, {
    sit: 'Cumplir con la Ley 27.621 de EAI',
    sin: 'No sabés por dónde empezar',
    con: 'Proyectos ambientales listos con marco legal incluido'
  }, {
    sit: 'Organizar una feria de ciencias meteorológica',
    sin: 'Improvisás sin guía',
    con: 'Guía completa de feria con roles, stands y evaluación'
  }, {
    sit: 'Trabajo interdisciplinario con otros docentes',
    sin: 'No tenés propuesta armada',
    con: 'Proyectos interdisciplinarios con Matemática, Lengua y Cs. Sociales'
  }, {
    sit: 'Adaptación curricular por provincia',
    sin: 'Buscás el diseño solo',
    con: 'Alineación curricular por nivel y jurisdicción resuelta'
  }, {
    sit: 'Evaluar proyectos de estación escolar',
    sin: 'Sin criterios claros',
    con: 'Rúbricas de evaluación por competencia listas'
  }];
  return <section id="pricing" className="py-24 bg-[#0f1d35]" data-id="element-201">
      <div className="container mx-auto px-4" data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-204">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-slate-300 text-[16px]" data-id="element-205">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-206">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#0a1428] rounded-3xl p-8 shadow-2xl border border-[#1e3a5f] flex flex-col h-full relative z-10" data-id="element-207">
            <div className="mb-6" data-id="element-208">
              <p className="text-slate-400 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-209">
                OPCIÓN 1 — Oferta principal
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-210">
                🌩️ MEGAPACK METEOROLOGÍA LISTO™
              </h3>
              <p className="text-slate-400 font-medium" data-id="element-211">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#1e3a5f]" data-id="element-212"></div>

            <div className="mb-8" data-id="element-213">
              <div className="flex items-end gap-2" data-id="element-214">
                <span className="text-5xl font-black text-white" data-id="element-215">$19.990</span>
                <span className="text-xl font-bold text-slate-400 mb-1" data-id="element-216">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-217">$45.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-218">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-219">
                  <span className="text-slate-300 text-[15px]" data-id="element-220">{feature}</span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47936696418498:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-221">
              <Button variant="outline" size="lg" fullWidth data-id="element-222">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#0a1428] rounded-3xl p-8 shadow-2xl border-2 border-slate-300 flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-223">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-slate-200 text-slate-950 font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-224">
              <Zap className="w-4 h-4 fill-slate-950" data-id="element-225" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-226">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-227">
                🌩️ MEGAPACK METEOROLOGÍA LISTO™ + NIVEL MAESTRO
              </h3>
              <p className="text-slate-300 font-bold" data-id="element-228">
                Todo lo anterior + Planificación & Proyectos
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-blue-900/50" data-id="element-229"></div>

            <div className="mb-8" data-id="element-230">
              <div className="flex items-end gap-2" data-id="element-231">
                <span className="text-5xl font-black text-white" data-id="element-232">$27.990</span>
                <span className="text-xl font-bold text-slate-300 mb-1" data-id="element-233">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-234">$75.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-235">
              {maestroFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-236">
                  <Zap className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-237" />
                  <span className={i >= 10 && i <= 11 ? 'text-slate-200 font-bold' : 'text-slate-300'} data-id="element-238">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47936696615106:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-239">
              <Button variant="premium" size="lg" fullWidth data-id="element-240">
                ⚡ QUIERO EL MEGAPACK + NIVEL MAESTRO
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-slate-400 text-sm mb-20" data-id="element-241">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Upsell Details */}
        <div className="max-w-4xl mx-auto" data-id="element-242">
          <div className="text-center mb-10" data-id="element-243">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white flex items-center justify-center gap-2" data-id="element-244">
              <Target className="w-8 h-8 text-slate-300" data-id="element-245" />
              🎯 ¿QUÉ AGREGA EL NIVEL MAESTRO?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-246">
            <div className="min-w-[700px]" data-id="element-247">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-248">
                <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-249">
                  Situación
                </div>
                <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-250">
                  ❌ Sin Nivel Maestro
                </div>
                <div className="font-bold text-slate-300 uppercase text-sm tracking-wider" data-id="element-251">
                  ✅ Con Nivel Maestro
                </div>
              </div>

              <div className="space-y-2" data-id="element-252">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-[#0a1428]/60 rounded-xl p-4 items-center border border-[#1e3a5f]" data-id="element-253">
                    <div className="text-slate-300 font-medium text-sm" data-id="element-254">
                      {row.sit}
                    </div>
                    <div className="text-red-300/80 text-sm" data-id="element-255">{row.sin}</div>
                    <div className="text-slate-200 font-medium text-sm" data-id="element-256">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#0f1d35] to-[#1e3a5f] rounded-2xl p-6 md:p-8 border border-slate-400/30 shadow-xl" data-id="element-257">
            <h4 className="font-bold text-slate-200 mb-6 uppercase tracking-wider" data-id="element-258">
              💼 NIVEL MAESTRO — ¿QUÉ INCLUYE?
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-259">
              <div className="space-y-6" data-id="element-260">
                <h5 className="font-bold text-slate-300 border-b border-[#2d4d75] pb-2" data-id="element-261">
                  💼 Meteorología Listo Planificaciones
                </h5>
                <div data-id="element-262">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-263">
                    <span className="text-slate-300" data-id="element-264">📊</span> PLANIFICACIÓN
                    ANUAL COMPLETA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-265">
                    Secuencia didáctica completa de meteorología para primaria y
                    secundaria. Con propósitos, contenidos, actividades,
                    recursos y criterios de evaluación. Lista para presentar y
                    para usar.
                  </p>
                </div>
                <div data-id="element-266">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-267">
                    <span className="text-slate-300" data-id="element-268">🗓️</span> PLANIFICACIÓN
                    SEMANAL LISTA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-269">
                    12 semanas de clases desarrolladas con objetivos diarios,
                    materiales necesarios y conexión con los tomos del Megapack.
                    Abrís el lunes y sabés exactamente qué hacer cada día.
                  </p>
                </div>
                <div data-id="element-270">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-271">
                    <span className="text-slate-300" data-id="element-272">📋</span> ADAPTACIONES
                    CURRICULARES
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-273">
                    El mismo contenido adaptado para diferentes jurisdicciones
                    argentinas. No importa si enseñás en Mendoza, Chaco,
                    Patagonia o Buenos Aires — tenés la planificación ajustada a
                    tu diseño curricular.
                  </p>
                </div>
                <div data-id="element-274">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-275">
                    <span className="text-slate-300" data-id="element-276">✅</span> RÚBRICAS DE
                    EVALUACIÓN
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-277">
                    Sistema completo de evaluación por competencias para todos
                    los tomos. Rúbricas para proyectos, experimentos, estación
                    escolar y trabajo áulico. Sin inventar criterios desde cero
                    nunca más.
                  </p>
                </div>
              </div>

              <div className="space-y-6" data-id="element-278">
                <h5 className="font-bold text-slate-300 border-b border-[#2d4d75] pb-2" data-id="element-279">
                  📣 Meteorología Listo Proyectos Escolares
                </h5>
                <div data-id="element-280">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-281">
                    <span className="text-slate-300" data-id="element-282">🌱</span> PROYECTOS EAI
                    COMPLETOS
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-283">
                    3 proyectos de Educación Ambiental Integral listos para
                    implementar, alineados con la Ley 27.621. Con objetivos,
                    actividades, cronograma, recursos y evaluación. Presentables
                    ante directivos y supervisores.
                  </p>
                </div>
                <div data-id="element-284">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-285">
                    <span className="text-slate-300" data-id="element-286">🔬</span> GUÍA DE FERIA DE
                    CIENCIAS METEOROLÓGICA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-287">
                    Cómo organizar una feria de ciencias completa con foco en
                    meteorología. Roles, stands, experimentos, presentaciones y
                    criterios de evaluación. Tu feria más organizada y
                    memorable.
                  </p>
                </div>
                <div data-id="element-288">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-289">
                    <span className="text-slate-300" data-id="element-290">🤝</span> PROYECTOS
                    INTERDISCIPLINARIOS
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-291">
                    5 proyectos que cruzan meteorología con Matemática
                    (estadísticas climáticas), Lengua (informes meteorológicos),
                    Ciencias Sociales (impacto del clima en la economía) y
                    Educación Física (clima y actividad física). Trabajo
                    conjunto con otros docentes ya resuelto.
                  </p>
                </div>
                <div data-id="element-292">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-293">
                    <span className="text-slate-300" data-id="element-294">📱</span> RECURSOS
                    DIGITALES PARA EL AULA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-295">
                    Guía completa de herramientas digitales gratuitas para
                    enseñar meteorología: SMN online, Windy, Earth.nullschool,
                    Google Earth y más. Con tutorial de uso y actividades
                    integradas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}